module.exports = __webpack_public_path__ + "img/couch_9.abca39a5.jpg";